import commonApi from './common'
import accessControlApi from './accessControl'
import serviceApi from './service'
import householdApi from './household'
import videoApi from './video'
import deviceApi from './device'
import alarmApi from './alarm'
import system from './system'

export default {
  // 共用
  ...commonApi,
  // 社區服務管理
  ...serviceApi,
  // 社區門禁管理
  ...accessControlApi,
  // 社區住戶
  ...householdApi,
  // 社區影像管理
  ...videoApi,
  // 設備管理
  ...deviceApi,
  // 事件告警紀錄
  ...alarmApi,
  // 系統管理
  ...system
}
